module.exports = __webpack_public_path__ + "img/Colombia.0550ff4e.svg";